import { roles } from '../../constants/user_roles';

import { BaseModel } from '../base';

class AdminUserModel extends BaseModel {

    constructor(data) {
        super(data);
        this.isParent = false;
        this.isPersonal = this.$has('person');
    }

    setParentRole(isParent = true) {
        this.isParent = isParent;
    }

    hasParentRole(){
        return this.isParent;
    }


    hasPersonalRole() {
        return this.isPersonal;
    }

    getOriginalRole() {
        return this.role;
    }

    getRole() {
        if (this.isPersonal) return roles.personal;
        if (this.isParent) return `parent-${this.role}`;
        return this.role;
    }
}

export {
    AdminUserModel
};
